enum ORGANIZATIONS_TOKENS_PARAMS {
    TOKEN_NAME_PARAM = 'tokenName',
    SYMBOL_PARAM = 'tokenSymbol',
    BALANCE_USD_PARAM = 'daosTotalUsdValue',
    ORGANIZATIONS_PARAM = 'numDaos',
}

export { ORGANIZATIONS_TOKENS_PARAMS };
